export enum ActivityAccountType {
  Bank = 'bank',
  Checking = 'checking',
  Credit = 'credit',
  Reserve = 'reserve',
  Savings = 'savings',
  TreasureReserve = 'treasure_reserve',
}
